export default {
    btnOk: 'ตกลง',
    btnCancel: 'ยกเลิก'
}
